import { parseDatenFile } from '@emdzej/ncsx-daten';
const SWT_BLOCK = 'SWT_EINTRAG';
/**
 * Build an `SwtTable` from an already-parsed `DatenFile`.
 */
export function indexSwt(file, source) {
    const byKeyword = new Map();
    const byKeyId = new Map();
    const block = file.blocks.find((b) => b.name === SWT_BLOCK);
    if (block) {
        for (const row of block.rows) {
            const id = row.KEYID;
            const kw = row.KEYWORD;
            if (typeof id === 'number' && typeof kw === 'string') {
                byKeyword.set(kw, id);
                byKeyId.set(id, kw);
            }
        }
    }
    return { byKeyword, byKeyId, source };
}
/**
 * Find the chassis's SWT lookup file by extension. NCSEXPER ships them as `SWT<KIND><NN>.DAT`
 * where `<KIND>` is one of `ASW`/`FSW`/`PSW` and `<NN>` is a 2-digit chassis revision.
 * Case-insensitive on disk.
 */
async function findSwtFile(source, chassisDir, kind) {
    const entries = await source.list(chassisDir).catch(() => []);
    const re = new RegExp(`^SWT${kind}[0-9A-Fa-f]{2}\\.dat$`, 'i');
    for (const entry of entries) {
        if (re.test(entry))
            return `${chassisDir}/${entry}`;
    }
    return undefined;
}
/**
 * Locate and load one SWT file from a chassis directory. Returns `undefined` if no matching
 * file is present (caller decides whether to warn).
 */
export async function loadSwtFile(source, chassisDir, kind) {
    const path = await findSwtFile(source, chassisDir, kind);
    if (!path)
        return undefined;
    const bytes = await source.read(path);
    const file = parseDatenFile(bytes);
    return indexSwt(file, path);
}
//# sourceMappingURL=swt.js.map